'use client';

import { useState } from 'react';
import type { CSSProperties } from 'react';

interface Props {
  text: string;
  maxLines?: number;
}

/**
 * Plain-Text-Beschreibung mit line-clamp; Klick togglet zwischen geclampt und voll.
 * Wird genutzt in TaskCardNeu, TaskCardArbeits und TaskCardNachbessern (Fokus-Modus).
 */
export function ExpandableDescription({ text, maxLines = 4 }: Props) {
  const [expanded, setExpanded] = useState(false);

  const clampStyle: CSSProperties = expanded
    ? {}
    : {
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      };

  return (
    <p
      onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
      style={clampStyle}
      className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed cursor-pointer whitespace-pre-line"
    >
      {text}
    </p>
  );
}
